var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c(
                "div",
                { staticClass: "wrapper" },
                [
                  _c("v-action-buttons", {
                    attrs: {
                      items: _vm.getActionButtons,
                      isDisabled: _vm.projectFormDisabled,
                    },
                    on: { actionClicked: _vm.onClickAction },
                  }),
                  _vm._v(" "),
                  _c("v-form-message", {
                    attrs: {
                      type: "error",
                      id: "form-error",
                      message: _vm.projectObjectError,
                      autoCloseTimeout: 5000,
                    },
                  }),
                  _vm._v(" "),
                  _c("v-form-message", {
                    attrs: {
                      type: "success",
                      id: "form-success",
                      message: _vm.projectObjectSuccess,
                    },
                  }),
                  _vm._v(" "),
                  _c("v-form-message", {
                    attrs: {
                      type: "default",
                      message: _vm.objectCheckTOK,
                      autoCloseTimeout: 0,
                      showActionButtons: true,
                    },
                    on: { onClickAction: _vm.onClickDialogAction },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-x grid-margin-x" }, [
                    _c("div", { staticClass: "cell medium-12 large-6" }, [
                      _c("div", { staticClass: "box" }, [
                        _c(
                          "div",
                          { staticClass: "grid-x grid-margin-x" },
                          [
                            _c("div", { staticClass: "cell small-3" }, [
                              _c("h2", [
                                _vm._v(
                                  _vm._s(_vm.$t("form.project.title.project"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.$store.getters.userIsAdmin
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell small-6 project-detail-status",
                                    },
                                    [
                                      _vm.object.location.risk
                                        ? [
                                            _vm.object.location.risk.is_valid &&
                                            _vm.object.location.risk
                                              .decided_budget
                                              ? _c("p", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "location.risk.limit"
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(
                                                          _vm.$helpers.formateCurrency(
                                                            _vm.object.location
                                                              .risk
                                                              .decided_budget
                                                          )
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                  ]),
                                                ])
                                              : _c("p", [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "u-color--alert",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "location.risk.not_valid"
                                                            )
                                                          ) +
                                                          "\n                              "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                          ]
                                        : [
                                            _c("p", [
                                              _c(
                                                "strong",
                                                {
                                                  staticClass: "u-color--alert",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "location.risk.no_risk_number"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "cell small-3 text-right" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "project-detail-status" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "status-icon",
                                        class:
                                          "status-icon--" + _vm.object.status,
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "status." + _vm.object.status
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid-x grid-margin-x" }, [
                          _c("div", { staticClass: "cell medium-6" }, [
                            _c("div", { staticClass: "form-block" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "form-group--error":
                                      _vm.$v.object.location_id.$error,
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "form-field-location" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("form.project.location"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-select-location", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "form.project.location.plc"
                                      ),
                                      tabindex: 1,
                                      customerId: _vm.$route.params.customer,
                                      isStatic:
                                        _vm.$store.getters.userIsProjectManager,
                                    },
                                    on: { change: _vm.onChangeLocation },
                                    model: {
                                      value: _vm.$v.object.location_id.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.object.location_id,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.object.location_id.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "form-group form-group--info" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("form.project.project_number")
                                    ) +
                                      ": " +
                                      _vm._s(_vm.object.project_number)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "form-group form-group--info" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("createdon_date")) +
                                      ": " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.object.createdon.date,
                                          _vm.$helpers.dateFormat.toUpperCase()
                                        )
                                      )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell medium-6" }, [
                            _c("div", { staticClass: "form-block" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "form-group--error":
                                      _vm.$v.object.account_id.$error,
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "form-field-pm" } },
                                    [_vm._v(_vm._s(_vm.$t("form.project.pm")))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-select-user", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "form.project.pm.plc"
                                      ),
                                      tabindex: 1,
                                      userType: _vm.$helpers.usertypes.pm,
                                      locationId:
                                        _vm.$v.object.location_id.$model,
                                      customerId: _vm.$route.params.customer,
                                      isStatic:
                                        _vm.$store.getters.userIsProjectManager,
                                    },
                                    on: { change: _vm.onChangeAccount },
                                    model: {
                                      value: _vm.$v.object.account_id.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.object.account_id,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.object.account_id.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "form-group" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("mobile")) +
                                    ": " +
                                    _vm._s(
                                      _vm.object.account.profile.communication
                                        .mobile
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "form-group" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("phone")) +
                                    ": " +
                                    _vm._s(
                                      _vm.object.account.profile.communication
                                        .phone
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "form-group" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("mail")) +
                                    ": " +
                                    _vm._s(
                                      _vm.object.account.profile.communication
                                        .email
                                    )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "box" }, [
                        _c(
                          "h2",
                          { staticClass: "u-extra-small-margin--bottom" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("form.project.title.location"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "callout warning text-center" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("project.message.onestreetperproject")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "grid-x grid-margin-x",
                            attrs: { id: "address-form-fields" },
                          },
                          [
                            _c("div", { staticClass: "cell medium-6" }, [
                              _c("div", { staticClass: "form-block" }, [
                                _c(
                                  "div",
                                  { staticClass: "grid-x grid-margin-x" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cell xxlarge-5 medium-4",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            class: {
                                              "form-group--error":
                                                _vm.$v.object.address.zipcode
                                                  .$error,
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.$v.object.address
                                                      .zipcode.$model,
                                                  expression:
                                                    "$v.object.address.zipcode.$model",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "loading-spinner--input":
                                                  _vm.geocodeLoading,
                                              },
                                              attrs: {
                                                type: "text",
                                                id: "form-field-zipcode",
                                                name: "zipcode",
                                                placeholder:
                                                  _vm.$t("form.zipcode.plc"),
                                                tabindex: 3,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.$v.object.address.zipcode
                                                    .$model,
                                              },
                                              on: {
                                                keyup: _vm.onChangeZipcode,
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.$v.object.address
                                                      .zipcode,
                                                    "$model",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cell xxlarge-7 medium-8",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            class: {
                                              "form-group--error":
                                                _vm.$v.object.address.city
                                                  .$error,
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.$v.object.address.city
                                                      .$model,
                                                  expression:
                                                    "$v.object.address.city.$model",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "loading-spinner--input":
                                                  _vm.geocodeLoading,
                                              },
                                              attrs: {
                                                type: "text",
                                                id: "form-field-city",
                                                name: "city",
                                                placeholder:
                                                  _vm.$t("form.city.plc"),
                                                tabindex: 4,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.$v.object.address.city
                                                    .$model,
                                              },
                                              on: {
                                                keyup: _vm.onChangeCity,
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.$v.object.address.city,
                                                    "$model",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "grid-x grid-margin-x" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cell xxlarge-12 large-4",
                                      },
                                      [
                                        _vm.geocodeObject.zipcode.length > 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group form-group__extra",
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    staticClass:
                                                      "form-control form-control--select",
                                                    attrs: {
                                                      name: "zipcode_list",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.onSelectZipcode,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "form.zipcode.choose"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.geocodeObject.zipcode,
                                                      function (item, index) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key:
                                                              index +
                                                              "_zipcode",
                                                            domProps: {
                                                              value:
                                                                item.zipcode,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.zipcode
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cell xxlarge-12 large-8",
                                      },
                                      [
                                        _vm.geocodeObject.city.length > 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group form-group__extra",
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    staticClass:
                                                      "form-control form-control--select",
                                                    attrs: {
                                                      name: "city_list",
                                                    },
                                                    on: {
                                                      change: _vm.onSelectCity,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "form.city.choose"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.geocodeObject.city,
                                                      function (item, index) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key:
                                                              index + "_city",
                                                            domProps: {
                                                              value: item.city,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.city)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "grid-x grid-margin-x" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cell medium-8" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            class: {
                                              "form-group--error":
                                                _vm.$v.object.address.street
                                                  .$error,
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.$v.object.address.street
                                                      .$model,
                                                  expression:
                                                    "$v.object.address.street.$model",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "form-field-street",
                                                name: "street",
                                                placeholder:
                                                  _vm.$t("form.street.plc"),
                                                tabindex: 5,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.$v.object.address.street
                                                    .$model,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.$v.object.address
                                                      .street,
                                                    "$model",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "cell medium-4" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.object.address
                                                      .housenumber,
                                                  expression:
                                                    "object.address.housenumber",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "form-field-housenumber",
                                                name: "housenumber",
                                                placeholder: _vm.$t(
                                                  "form.housenumber.plc"
                                                ),
                                                tabindex: 6,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.object.address
                                                    .housenumber,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.object.address,
                                                    "housenumber",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("form.project.site_comments")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.object.site_comments,
                                        expression: "object.site_comments",
                                      },
                                    ],
                                    staticClass:
                                      "form-control form-control--textarea",
                                    attrs: {
                                      id: "form-field-site-comments",
                                      name: "site_comments",
                                      placeholder: _vm.$t(
                                        "form.project.site_comments.plc"
                                      ),
                                      tabindex: 7,
                                    },
                                    domProps: {
                                      value: _vm.object.site_comments,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.object,
                                          "site_comments",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "form.project.site_contact_label"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.object.site_contact_info,
                                        expression: "object.site_contact_info",
                                      },
                                    ],
                                    staticClass: "form-control--textarea",
                                    attrs: {
                                      id: "form-field-site-contact-info",
                                      name: "site_contact_info",
                                      placeholder: _vm.$t(
                                        "form.project.site_contact_info.plc"
                                      ),
                                      tabindex: 8,
                                    },
                                    domProps: {
                                      value: _vm.object.site_contact_info,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.object,
                                          "site_contact_info",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.object.internal_number.$error,
                                    },
                                  },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.object.internal_number
                                              .$model,
                                          expression:
                                            "$v.object.internal_number.$model",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control--textarea form-control--highlighted",
                                      attrs: {
                                        id: "form-field-internal-number",
                                        name: "internal_number",
                                        placeholder: _vm.$t(
                                          "form.project.internal_number.plc"
                                        ),
                                        tabindex: 9,
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.object.internal_number.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.object.internal_number,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cell medium-6" }, [
                              _c("div", { staticClass: "form-block" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--maps",
                                    },
                                    [
                                      _c("v-google-map", {
                                        attrs: {
                                          address:
                                            _vm.object.address.street +
                                            " " +
                                            _vm.object.address.housenumber +
                                            " " +
                                            _vm.object.address.city +
                                            " " +
                                            _vm.object.address.zipcode,
                                          resize: !_vm.isLoading,
                                          tabindex: -1,
                                          zoom: 10,
                                          zoomControl: true,
                                          panControl: true,
                                          useFitBounds: false,
                                        },
                                        on: { marker: _vm.getMarker },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid-x grid-margin-x" }, [
                          _c("div", { staticClass: "cell medium-6" }, [
                            _c("div", { staticClass: "form-block" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group",
                                  class: {
                                    "form-group--error":
                                      _vm.$v.object.earliest_start.$error,
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "form-field-earliest-start",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("form.project.earliest_start")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "form-help" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "form.project.earliest_start.help"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-datepicker", {
                                    staticClass:
                                      "form-control form-control--date",
                                    attrs: {
                                      id: "form-field-earliest-start",
                                      placeholder: _vm.$t(
                                        "form.project.earliest_start.plc"
                                      ),
                                      format: _vm.$helpers.dateFormat,
                                      "disabled-dates":
                                        _vm.earliestStartDisabledDates,
                                      language: _vm.de,
                                      "monday-first": true,
                                      tabindex: 10,
                                    },
                                    model: {
                                      value:
                                        _vm.$v.object.earliest_start.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.object.earliest_start,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.object.earliest_start.$model",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.$v.object.earliest_start.$error
                                    ? _c(
                                        "p",
                                        { staticClass: "form-help u-error" },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(_vm.earliestStartError) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "form-field-earliest-start-comment",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "form.project.earliest_start_comment"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.object.earliest_start_comment,
                                      expression:
                                        "object.earliest_start_comment",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    id: "form-field-earliest-start-comment",
                                    name: "earliest_start_comment",
                                    maxlength: "255",
                                    placeholder: _vm.$t(
                                      "form.project.earliest_start_comment.plc"
                                    ),
                                    tabindex: 11,
                                  },
                                  domProps: {
                                    value: _vm.object.earliest_start_comment,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.object,
                                        "earliest_start_comment",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.$store.getters.userIsAdmin
                        ? _c("section", { staticClass: "box" }, [
                            _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c("div", { staticClass: "cell small-12" }, [
                                _c("h2", [
                                  _vm._v(
                                    _vm._s(_vm.$t("project.internalarea.title"))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "cell small-12" }, [
                                _c("div", { staticClass: "form-block" }, [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("project.internal_note"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.object.internal_note,
                                          expression: "object.internal_note",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control--textarea",
                                      attrs: {
                                        id: "form-field-internal-note",
                                        name: "internal_note",
                                        tabindex: 12,
                                      },
                                      domProps: {
                                        value: _vm.object.internal_note,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.object,
                                            "internal_note",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell medium-12 large-6" }, [
                      _c("div", { staticClass: "box" }, [
                        _c(
                          "div",
                          {
                            staticClass: "grid-x grid-margin-x grid-padding-x",
                          },
                          [
                            _c("div", { staticClass: "cell medium-7" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "loading-wrapper",
                                  class: { "is-loading": _vm.layersLoading },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "loading-message" },
                                    [_vm._v(_vm._s(this.$t("results_loading")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "layer-stats layer-stats--overview",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "layer-stats--overview__item layer-stats--overview__item--total",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$helpers.formatNumber(
                                                  _vm.layersStats.total
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("qm_total")) +
                                              "\n                              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "layer-stats--overview__item layer-stats--overview__item--finished",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$helpers.formatNumber(
                                                  _vm.layersStats.finished
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("status.finished")
                                              ) +
                                              "\n                              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "layer-stats--overview__item layer-stats--overview__item--open",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$helpers.formatNumber(
                                                  _vm.layersStats.open
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("status.open")) +
                                              "\n                              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cell medium-5" }, [
                              _c("div", { staticClass: "form-block" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group form-group--check",
                                  },
                                  [
                                    _c("label", { staticClass: "large" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.object.layer_hole,
                                            expression: "object.layer_hole",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          name: "layer_hole",
                                          value: "1",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.object.layer_hole
                                          )
                                            ? _vm._i(
                                                _vm.object.layer_hole,
                                                "1"
                                              ) > -1
                                            : _vm.object.layer_hole,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.object.layer_hole,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "1",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.object,
                                                    "layer_hole",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.object,
                                                    "layer_hole",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.object,
                                                "layer_hole",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i"),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("form.project.layer_hole")
                                          ) +
                                          "\n                              "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group form-group--check",
                                  },
                                  [
                                    _c("label", { staticClass: "large" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.object.layer_tok,
                                            expression: "object.layer_tok",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          name: "layer_tok",
                                          value: "1",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.object.layer_tok
                                          )
                                            ? _vm._i(
                                                _vm.object.layer_tok,
                                                "1"
                                              ) > -1
                                            : _vm.object.layer_tok,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.object.layer_tok,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "1",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.object,
                                                    "layer_tok",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.object,
                                                    "layer_tok",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.object,
                                                "layer_tok",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i"),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("form.project.layer_tok")
                                          ) +
                                          "\n                              "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group form-group--check",
                                  },
                                  [
                                    _c("label", { staticClass: "large" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.object.layer_installation,
                                            expression:
                                              "object.layer_installation",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          name: "layer_installation",
                                          value: "1",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.object.layer_installation
                                          )
                                            ? _vm._i(
                                                _vm.object.layer_installation,
                                                "1"
                                              ) > -1
                                            : _vm.object.layer_installation,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  _vm.object.layer_installation,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = "1",
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.object,
                                                      "layer_installation",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.object,
                                                      "layer_installation",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.object,
                                                  "layer_installation",
                                                  $$c
                                                )
                                              }
                                            },
                                            _vm.onChangeLayerInstallation,
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i"),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              "form.project.layer_installation"
                                            )
                                          ) +
                                          "\n                              "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: this.object.layer_installation,
                                        expression:
                                          "this.object.layer_installation",
                                      },
                                    ],
                                    staticClass: "form-group form-group--check",
                                  },
                                  [
                                    _c("label", { staticClass: "large" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("form.project.layer_width")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form-group-toggle" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-container full",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "grid-x" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell medium-4 large-5",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.object
                                                              .layer_width_min,
                                                          expression:
                                                            "object.layer_width_min",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control--small",
                                                      attrs: {
                                                        type: "text",
                                                        id: "form-element-layer-width-min",
                                                        name: "layer_width_min",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.object
                                                            .layer_width_min,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.object,
                                                            "layer_width_min",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell medium-3 large-auto",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-control form-control--small form-control--seperator",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.$t("till"))
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell medium-4 large-5",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.object
                                                              .layer_width_max,
                                                          expression:
                                                            "object.layer_width_max",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control--small",
                                                      attrs: {
                                                        type: "text",
                                                        id: "form-element-layer-width-min",
                                                        name: "layer_width_max",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.object
                                                            .layer_width_max,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.object,
                                                            "layer_width_max",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.$t("form.project.title.default_layers"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "layers layers--overview loading-wrapper",
                            class: { "is-loading": _vm.layersLoading },
                          },
                          [
                            _c("div", { staticClass: "loading-message" }, [
                              _vm._v(_vm._s(this.$t("results_loading"))),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sortLayers, function (layer, index) {
                              return _c(
                                "div",
                                { key: index + "_sortLayers" },
                                [
                                  layer.is_default
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "layers--overview__item",
                                          },
                                          [
                                            _c("v-project-layer", {
                                              attrs: {
                                                layer: layer,
                                                projectId: _vm.object.id,
                                              },
                                              on: {
                                                change: _vm.onChangeLayer,
                                                changeField:
                                                  _vm.onUpdateLayersStats,
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.object.layers.$each
                                                    .$iter[layer.id],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.$v.object.layers.$each
                                                      .$iter,
                                                    layer.id,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.object.layers.$each.$iter[layer.id]",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "box__title" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("form.project.title.addition_layers")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "form.project.title.addition_layers.total",
                                  {
                                    total: _vm.$helpers.formatNumber(
                                      _vm.layersStats.layers.addition
                                    ),
                                  }
                                )
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "layers layers--overview loading-wrapper",
                            class: { "is-loading": _vm.layersLoading },
                          },
                          [
                            _c("div", { staticClass: "loading-message" }, [
                              _vm._v(_vm._s(this.$t("results_loading"))),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sortLayers, function (layer, index) {
                              return _c(
                                "div",
                                { key: index + "_sort_layers_2" },
                                [
                                  !layer.is_default
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "layers--overview__item",
                                          },
                                          [
                                            _c("v-project-layer", {
                                              attrs: {
                                                layer: layer,
                                                projectId: _vm.object.id,
                                              },
                                              on: {
                                                change: _vm.onChangeLayer,
                                                changeField:
                                                  _vm.onUpdateLayersStats,
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.object.layers.$each
                                                    .$iter[layer.id],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.$v.object.layers.$each
                                                      .$iter,
                                                    layer.id,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.object.layers.$each.$iter[layer.id]",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }